import React from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Popover, Text } from '@amzn/storm-ui';

import { CustomButton } from '../../../UiComponentsLibrary/CustomButton';
import { CustomButtonColor } from '../../../UiComponentsLibrary/CustomButton/constants/CustomButtonColor';

interface DeletedUserRestorePopoverProps {
  isOpen: boolean;
  onClose: () => void;
  trigger: React.ReactElement;
  userId: string;
  onRestore: () => void;
}

const DeletedUserRestorePopover: React.FC<DeletedUserRestorePopoverProps> = ({
  isOpen,
  onClose,
  trigger,
  userId,
  onRestore,
}) => {
  const { t } = useTranslation();

  return (
    <Popover
      id="deleted-user-restore-popover"
      isOpen={isOpen}
      trigger={trigger}
      withCloseButton
      autoFocus
      onCloseButtonClick={onClose}
    >
      <Flex direction="column" justifyContent="flex-end" rowGap="small">
        <Text>
          {t('deleted-user-creation-popover-restore-message', {
            userId,
          })}
        </Text>
        <Flex direction="row" justifyContent="flex-end" columnGap="small">
          <CustomButton
            id="deleted-user-restore-cancel-button"
            text={t('deleted-user-creation-popover-cancel-button-label')}
            backgroundColor={CustomButtonColor.cancel}
            handleOnClickCb={onClose}
          />
          <CustomButton
            id="deleted-user-restore-success-button"
            text={t('deleted-user-creation-popover-restore-button-label')}
            backgroundColor={CustomButtonColor.submit}
            handleOnClickCb={onRestore}
          />
        </Flex>
      </Flex>
    </Popover>
  );
};

export default DeletedUserRestorePopover;
